import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  CHANGE_PLAYER_BONUS_API_URL,
  CHANGE_PLAYER_BONUS_MUTATION_KEY,
  PLAYERS_BONUSES_LIST_QUERY_KEY,
  PLAYERS_BONUSES_PERMISSIONS,
} from '@modules/players-bonuses/constants';
import { useToastStore } from '@modules/toast/store';

export default function useChangePlayersBonusesMutation(): ReturnType<
    typeof useContextMutation<void, Error, number>
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [CHANGE_PLAYER_BONUS_MUTATION_KEY],
    mutationFn: (bonusNr) => fetchDelete<void>(
      CHANGE_PLAYER_BONUS_API_URL(bonusNr),
      { permission: PLAYERS_BONUSES_PERMISSIONS.PLAYERS_BONUSES_DELETE },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [PLAYERS_BONUSES_LIST_QUERY_KEY] });
      displayPresetToast('removed');
    },
  });
}
